import React from 'react';
import { motion } from 'framer-motion';
import { Building2, UserPlus, Sparkles } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    number: '1',
    title: 'Creamos tu obra',
    icon: <Building2 className="w-8 h-8 text-blue-600" data-id="element-136" />
  }, {
    number: '2',
    title: 'Agregas nuestro número al grupo',
    icon: <UserPlus className="w-8 h-8 text-blue-600" data-id="element-137" />
  }, {
    number: '3',
    title: 'Nuestra IA ordena automáticamente',
    icon: <Sparkles className="w-8 h-8 text-blue-600" data-id="element-138" />
  }];
  return <section id="como-funciona" className="py-16 sm:py-24 bg-gray-50" data-id="element-139">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <div className="text-center mb-12 sm:mb-16" data-id="element-141">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900" data-id="element-142">
            Así de simple
          </h2>
        </div>

        <div className="relative" data-id="element-143">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gray-200 -translate-y-1/2 z-0" data-id="element-144"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-10 relative z-10" data-id="element-145">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-146">
                <div className="relative mb-6" data-id="element-147">
                  <div className="w-20 h-20 bg-white rounded-2xl border border-gray-200 shadow-sm flex items-center justify-center" data-id="element-148">
                    {step.icon}
                  </div>
                  <div className="absolute -top-3 -right-3 w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-sm border-2 border-gray-50" data-id="element-149">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 max-w-[200px]" data-id="element-150">
                  {step.title}
                </h3>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-12 sm:mt-20 px-4" data-id="element-151">
          <p className="text-lg sm:text-xl font-semibold text-gray-800 inline-block relative" data-id="element-152">
            Transformamos comunicación informal en documentación formal.
            <span className="absolute -bottom-2 left-0 w-full h-1 bg-blue-500 rounded-full opacity-20" data-id="element-153"></span>
          </p>
        </motion.div>
      </div>
    </section>;
}